import styled from 'styled-components';
import { FlexBox, StackPanel, Typography, typographyPresets } from '@agilepoint/wat-react-ux';
import { ColorPickerCalloutField, IconButton, RadioGroupField } from 'common';

export const AppStyleFields = styled(RadioGroupField)`
    width: auto;
    box-sizing: border-box;
    padding: 30px;
    justify-content: center;

    .ap-radioGroup-options-wrapper {
        width: 100%;
    }

    .ap-radio-child-items {
        gap: 15px;
    }
    
    .ap-radiobutton > span {
        ${typographyPresets.headings.h4};
    }
`;

export const ColorSetWrapper = styled(FlexBox) <{ $borderColor: string, $isSelected?: boolean, $isDisabled?: boolean }>`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin: 0 !important;
    border: 1px solid ${({ $borderColor }) => $borderColor};
    cursor: pointer;
    box-sizing: border-box;
    pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};
    outline: ${({ $isSelected, theme }) => ($isSelected ? '3px solid ' + theme.semantics.palette.themePrimary : 'none')};
    outline-offset: 5px;
    background: ${({ $borderColor }) => `linear-gradient(90deg, #fff 50%, ${$borderColor} 50%)`};
`;

export const CustomColorSetWrapper = styled(FlexBox)`
    width: 310px;
    height: 40px;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 0px 15px; 
    gap: 15px;
    border: 1px solid ${({ theme: { mobileAppAccelerator } }) => mobileAppAccelerator.semanticColors.grayVariant4};

    h6 {
        opacity: 0.6;
        text-transform: capitalize;
    };
`;

export const StyledIcon = styled(IconButton) <{ fill: string }>`
    .ap-icon {
        fill: ${({ fill }) => fill} !important;
    }
    cursor: pointer;
`;

export const PredefinedColorsRadioGroupField = styled(RadioGroupField)`
    .ap-radioGroup-options-wrapper {
        gap: 15px;
        flex-direction: row;
    }
`;

export const StyledColorPickerCalloutField = styled(ColorPickerCalloutField) <{ $isDisabled?: boolean }>`
    pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'visible')};
    width: auto;
    .ap-color-picker-callout {
        display: flex;
    }
`;

export const PreviewWrapper = styled(StackPanel)`
    padding: 30px;
    overflow-x: auto;
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.mobileAppAccelerator.semanticColors.grayVariant6};
    overflow-x: hidden;
    max-width: calc(100% - 455px);
`;

export const StyledSeparatorLabel = styled(Typography.H5)`
    color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant3};
`;

export const StyledStylingContainer = styled(FlexBox)`
    border: 1px solid ${({ theme }) => theme.mobileAppAccelerator.semanticColors.grayVariant5};
    box-sizing: border-box;
    border-radius: ${(props)=>props.theme.semantics.borderRadius.curvedLarge};
`;

export const StyledNavigationButtons = styled(IconButton)`
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.1), 0 1px 2px 0 rgba(0,0,0,0.06);
    border-radius: 100%;
    width: 30px;
    height: 30px;
`;
